/**
 * DeepL: translate and write with AI
 *
 * 223 static resources exposed to every origin — the largest surface in the top 40.
 * Manifest verified against version 1.95.0.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'cofdbpoegempjloogbagkncekinflcnj';
export const deepl: ExtensionDefinition = {
  id: ID,
  name: 'DeepL: translate and write with AI',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 4_000_000,
  notes: '223 static web-accessible resources exposed to <all_urls>.',
  signals: [
    { id: 'war-onboarding-html', kind: 'web-accessible-resource',
      description: 'Fetch onboarding.html — the first-run UI, exposed to <all_urls>.',
      weight: 1, run: () => probeFetch(ID, 'onboarding.html') },
    { id: 'war-content-css', kind: 'web-accessible-resource',
      description: 'Fetch build/content.css — the injected translator widget stylesheet.',
      weight: 0.5, run: () => probeFetch(ID, 'build/content.css') },
  ],
};
